<template lang="pug">
div
  .form-field-label(v-if="label")
    span {{ `${label}` }}
    span.form-field-require-tag(v-show="required") *
    hint-component(v-if="hint", :text="hint")

  .form-field.form-input(:class="invalidClass")
    q-input(
      filled,
      no-error-icon,
      v-model="value",
      @input="changeValue",
      :readonly="readonly",
      :placeholder="placeholder",
      :label-slot="false",
      autocomplete="off"
    )
      q-icon.cancel-string-field(name="cancel", v-if="value && !readonly", @click.stop="resetValue")

  .valid-error-message(v-if="invalid") {{ errorMessage }}
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import hintComponent from "../../helpers/hint.vue";

const props = defineProps({
  label: { type: String, default: "", required: false },
  required: { type: Boolean, default: false, required: false },
  initialValue: { type: String || null, default: null, required: false },
  placeholder: { type: String, default: "", required: false },
  readonly: { type: Boolean, default: false, required: false },
  /**
   * Флаг отвечающий за валидность поля. Включает подсветку с ошибкой и текстом errorMessage
   */
  invalid: { type: Boolean, default: false, required: false },
  /**
   * Текст отображаемый при невалидном поле
   */
  errorMessage: { type: String, default: "", required: false },
  /** Проп для вывода подсказки */
  hint: { type: String || null, default: () => null },
  /** Проп для вотча на значение select из ключа select в этом пропе и назначения значений текущего поля согласно значению select из ключа values */
  watchSelectValue: { type: Object, default: () => {} },
  /** Текущее значение селекта который мы вотчим из watchSelectValue */
  selectValueForWatch: { type: String || Number || null, default: () => null },
});

const emit = defineEmits(["change", "reset"]);

const value = ref(props.initialValue);

const invalidClass = computed(() => (props.invalid ? "valid-error" : ""));
const selectValueForWatch = computed(() => props.selectValueForWatch);

const changeValue = () => {
  emit("change", { value: value.value });
};

const updateValueFromSelectWatch = val => {
  value.value = val;
  changeValue();
};

const resetValue = () => {
  value.value = null;
  emit("reset");
  changeValue();
};

watch(selectValueForWatch, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    const newFieldValue = props.watchSelectValue?.values?.[newVal] ?? "";
    updateValueFromSelectWatch(newFieldValue);
  }
});
</script>

<script>
export default {
  name: "StringField",
};
</script>
